<template>
    <div id="dashboard-page">
        <div class="dashboard-layout">
            <div class="dashboard-row">
                <add-order
                    v-if="$module('point_of_sale') && ['insert'].includes(dashboardLevel)"
                    @orderSaved="orderSaved"
                    :show-date="showDate"
                />
                <search-client v-if="['read', 'insert'].includes(dashboardLevel)" :last-order="lastOrder" />
            </div>
            <div class="dashboard-row dashboard-row--single">
                <validate-coupon v-if="$module('coupons') && ['insert'].includes(dashboardLevel)"></validate-coupon>
            </div>
        </div>
    </div>
</template>
<style scoped lang="less">
#dashboard-page {
    padding: 8px 4px 24px;
}

.dashboard-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 1280px;
}

.dashboard-row {
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(300px, 0.85fr);
    gap: 16px;
    align-items: start;

    &--single {
        grid-template-columns: 1fr;
    }
}

::v-deep {
    .add-order,
    .search-client.box,
    .validate-coupon.box {
        padding: 24px;
        border-radius: 16px;
        border: 1px solid #e5e7eb;
        background: #fff;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
        min-width: 0;
    }

    .add-order,
    .search-client,
    .validate-coupon {
        h3 {
            font-family: "Sora", sans-serif;
            font-size: 18px;
            line-height: 1.3;
            color: #101828;
            font-weight: 600;
            margin: 0 0 20px;
            text-transform: none;
            letter-spacing: -0.01em;
        }

        label {
            display: block;
            margin-bottom: 6px;
            font-size: 13px;
            font-weight: 500;
            color: #344054;
        }

        .field {
            margin-bottom: 14px;
        }

        .form-control,
        input.form-control,
        select.form-control,
        textarea.form-control {
            border-radius: 10px;
            border-color: #d0d5dd;
            min-height: 40px;
            box-shadow: none;

            &:focus {
                border-color: #00542e;
                box-shadow: 0 0 0 3px rgba(0, 84, 46, 0.12);
            }
        }

        .buttons {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 8px;
            margin-top: 20px;
            float: none;

            > * {
                margin-left: 0;
            }
        }

        .btn.btn-primary {
            border-radius: 10px;
            border: none;
            background: #00542e;
            min-height: 40px;
            padding: 8px 16px;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            gap: 8px;

            &:hover:not(:disabled) {
                background: #064e2b;
            }

            &:disabled {
                opacity: 0.55;
            }
        }

        .message {
            float: none;
            display: block;
            margin: 8px 0 0;
            font-size: 13px;
        }
    }

    .search-client {
        width: 100%;
        flex-basis: auto;
        flex-shrink: 1;

        .info {
            margin-top: 12px;
            padding: 10px 12px;
            border-radius: 10px;
            background: #f9fafb;
            border: 1px solid #f2f4f7;
            font-size: 13px;
            color: #344054;

            a {
                color: #00542e;
                font-weight: 500;
                margin-left: 4px;
            }

            strong {
                color: #101828;
                font-weight: 600;
            }
        }

        .alert {
            height: auto;
            border-radius: 10px;
            margin-bottom: 8px;
        }
    }

    .validate-coupon {
        .row {
            margin-left: 0;
            margin-right: 0;
        }

        .col-sm-12 {
            padding-left: 0;
            padding-right: 0;
        }

        .form-control {
            margin-bottom: 0;
        }

        button {
            float: none;
            margin-top: 12px;
        }
    }

    .add-order {
        button {
            float: none;
        }
    }
}

@media (max-width: 980px) {
    .dashboard-row {
        grid-template-columns: 1fr;
    }

    ::v-deep {
        .search-client {
            width: 100%;
        }
    }
}
</style>
<script>
import addOrder from "./add-order/add-order";
import validateCoupon from "./validate-coupon/validate-coupon";
import HumanDate from "../components/human-date/human-date";
import SearchClient from "./search-client/search-client";
import Stripo from "../components/stripo/stripo";

export default {
    name: "Dashboard",
    components: {
        Stripo,
        SearchClient,
        HumanDate,
        "add-order": addOrder,
        "validate-coupon": validateCoupon,
    },
    data: function () {
        return {
            formLink: null,
            lastOrder: {
                client: {},
                order: {
                    id: null,
                    amount: null,
                },
            },
        };
    },
    computed: {
        showDate() {
            const options = this.$module("point_of_sale");
            if (options.showDateOnPOS) {
                return true;
            }
            return false;
        },
        dashboardLevel(){
            return this.$store.state.user.permissions.dashboard.options.level;
        }
    },
    mounted: function () {
        document.getElementsByTagName("title")[0].innerText = "Kevi | " + this.t('dashboard-title');
    },
    beforeCreate() {
        const permissionKey = 'dashboard';

        const user = this.$store.state.user;
        const permissions = user?.permissions || {};
        const permissionObj = permissions[permissionKey];

        const hasPermission = permissionObj?.enabled == 1;

        if (!hasPermission) {
            this.$router.replace("/tasks");
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        orderSaved(order) {
            this.lastOrder = order;
            if (this.lastOrder) {
                this.lastOrder.mixpanel = false;
            }
        },
    },
};
</script>
